// Status color mapping
export const statusColors = {
    OPEN: {
        bg: '#FEF3C7',
        color: '#D97706',
        icon: 'AlertTriangle',
        backgroundColor: '#FEF3C7'
    },
    'IN PROGRESS': {
        bg: '#DBEAFE',
        color: '#3B82F6',
        icon: 'Clock',
        backgroundColor: '#DBEAFE'
    },
    SCHEDULED: {
        bg: '#E0E7FF',
        color: '#6366F1',
        icon: 'Calendar',
        backgroundColor: '#E0E7FF'
    },
    RESOLVED: {
        bg: '#D1FAE5',
        color: '#10B981',
        icon: 'CheckCircle',
        backgroundColor: '#D1FAE5'
    },
    CLOSED: {
        bg: '#F3F4F6',
        color: '#6B7280',
        icon: 'XCircle',
        backgroundColor: '#F3F4F6'
    }
};

// Default status
export const defaultStatus = {
    bg: '#F3F4F6',
    color: '#6B7280',
    icon: 'AlertTriangle',
    backgroundColor: '#F3F4F6'
};

// Priority color mapping
export const priorityColors = {
    High: {bg: '#FEE2E2', color: '#EF4444'},
    HIGH: {bg: '#FEE2E2', color: '#EF4444'},
    Medium: {bg: '#FEF3C7', color: '#F59E0B'},
    MEDIUM: {bg: '#FEF3C7', color: '#F59E0B'},
    Low: {bg: '#D1FAE5', color: '#10B981'},
    LOW: {bg: '#D1FAE5', color: '#10B981'},
};

// Default priority
export const defaultPriority = {bg: '#F3F4F6', color: '#6B7280'};